import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/seats/license.seats.revoke.mutation.gql"
import type {
  LicenseSeatRevokeMutation,
  LicenseSeatRevokeMutationVariables,
} from "@/v2-backoffice-client/license/seats/__types__/license.seats.revoke.mutation"

type Options = MutationHookOptions<
  LicenseSeatRevokeMutation,
  LicenseSeatRevokeMutationVariables
>

export function useLicenseSeatRevokeMutation(options?: Options) {
  return useMutation<
    LicenseSeatRevokeMutation,
    LicenseSeatRevokeMutationVariables
  >(mutation, options)
}
